// extracted by mini-css-extract-plugin
export var link = "_s2-0";